import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 30px;
  margin: 0 0 15px 0;
`;

export const HeaderTitle = styled.span`
  font-size: 14px;
  margin-right: 70px;
  color: ${(props) => props.theme.colors.darkerblue};
  font-weight: 700;
  @media (max-width: 870px) {
    margin-right: 0px;
  }
`;

export const GraphWrapper = styled.div`
  width: ${(props) => (props.full ? `90%` : `75%`)};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr 1fr;
`;

export const Tag = styled.div`
  width: 38px;
  height: 12px;
  border-radius: 10px;
  background: ${(props) => props.background};
  margin: 0 15px;
`;

export const UpdateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${(props) => props.color};
  margin: 0 20px;
`;
